<template>
  <div>
    <div class="row" id="plan-header-container">
      <h1>Activate your Authentic.net account</h1>
      <p>The best solution for protecting your brand and gaining trust from your customers, built to scale. Upgrade as you grow or cancel anytime.</p>
    </div>
    <div class="row" ref="plans">
      <div class="col-md-4">
        <div class="card plan-card not-featured-plan">
          <div class="card-header">
            <h3 class="card-title">Business Startup 500</h3>
            <p class="category">$49.99 PER MONTH</p>
          </div>
          <button v-if="!plans[0].loading" class="btn btn-success btn-fill" @click.prevent="selectPlan(0)">Activate plan</button>
          <button type="button" v-if="plans[0].loading" class="btn btn-success" disabled="disabled">
            <span class="btn-label">
              <i class="fa fa-circle-o-notch fa-spin"></i>
            </span>
            Activate plan
          </button>
          <div class="no-cc-required">No credit card required</div>
          <div class="card-content">
            <div class="plan-desc"><h6>Business startup essentials</h6></div>
            <h6 class="plan-inc">Includes:</h6>
            <ul>
              <li><div>Protect products with 500 Authentic labels per month</div></li>
              <li><div>Digital Dashboard</div></li>
              <li><div>Amazon.com + 1 additional Retailer / Sales Channel</div></li>
              <li><div>1 User</div></li>
              <li><div>1 Brand</div></li>
              <li><div>Dymo Printer Integration</div></li>
              <li><div>FBA / Marketplace label printing</div></li>
              <li><div>Unlimited Products / Variations</div></li>
              <li><div>Ideal for Small Business Startups</div></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card plan-card featured-plan">
          <div class="card-header">
            <h2 class="card-title">Small Business 2000</h2>
            <p class="category">$89.99 PER MONTH</p>
          </div>
          <button v-if="!plans[1].loading" class="btn btn-success btn-fill" @click.prevent="selectPlan(1)">Activate plan</button>
          <button type="button" v-if="plans[1].loading" class="btn btn-success" disabled="disabled">
            <span class="btn-label">
              <i class="fa fa-circle-o-notch fa-spin"></i>
            </span>
            Activate plan
          </button>
          <div class="no-cc-required">No credit card required</div>
          <div class="card-content">
            <div class="plan-desc"><h6>Flexibility for growth</h6></div>
            <h6 class="plan-inc">Includes:</h6>
            <ul>
              <li><div>Protect products with 2000 Authentic labels per month (1000 per brand)</div></li>
              <li><div>Digital Dashboard</div></li>
              <li><div>All Amazon + 2 additional Retailers / Sales Channels</div></li>
              <li><div>2 Users</div></li>
              <li><div>2 Brands</div></li>
              <li><div>Dymo Printer Integration</div></li>
              <li><div>FBA / Marketplace label printing</div></li>
              <li><div>Unlimited Products / Variations</div></li>
              <li><div>Enhanced security &amp; encryption</div></li>
              <li><div>Perfect for the growing Small Business</div></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card plan-card not-featured-plan">
          <div class="card-header">
            <h3 class="card-title">Growing Professional 8000</h3>
            <p class="category">$199 PER MONTH</p>
          </div>
          <button v-if="!plans[2].loading" class="btn btn-success btn-fill" @click.prevent="selectPlan(2)">Activate plan</button>
          <button type="button" v-if="plans[2].loading" class="btn btn-success" disabled="disabled">
            <span class="btn-label">
              <i class="fa fa-circle-o-notch fa-spin"></i>
            </span>
            Activate plan
          </button>
          <div class="no-cc-required">No credit card required</div>
          <div class="card-content">
            <div class="plan-desc"><h6>Stability at scale</h6></div>
            <h6 class="plan-inc">Includes:</h6>
            <ul>
              <li><div>Protect products with 8000 Authentic labels per month (2000 per brand)</div></li>
              <li><div>Digital Dashboard</div></li>
              <li><div>All Amazon + 4 additional Retailers / Sales Channels</div></li>
              <li><div>4 Users</div></li>
              <li><div>4 Brands</div></li>
              <li><div>Dymo Printer Integration</div></li>
              <li><div>FBA / Marketplace label printing</div></li>
              <li><div>Unlimited Products / Variations</div></li>
              <li><div>Enhanced security &amp; encryption</div></li>
              <li><div>Digital Branded Landing Page</div></li>
              <li><div>Digital Registration Warranty Page</div></li>
              <li><div>Perfect for the growing Small Business</div></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row" ref="planPayment">
      <form v-show="model.plan_id" method="#" action="#" @submit.prevent="submit()">
        <div class="card" style="padding: 20px; text-align: center;">
          <h3>Selected Plan</h3>
          <h5>{{plan.name}}</h5>
          <h6>${{plan.amount}} per {{plan.interval}} - starting {{plan.startDate}}</h6>
          <div class="content">
            <div class="form-group">
              <card class='stripe-card'
                :class='stripeSettings.class'
                :stripe='stripeSettings.pubKey'
                :options='stripeSettings.options'
                :style='stripeSettings.style'
                @change='complete = $event.complete'
              />
            </div>
            <div v-show="false" class="form-group">
              <input type="text" v-model="model.coupon" placeholder="Coupon Code" class="form-control">
            </div>
          </div>
          <div class="footer text-center">
            <button type="button" v-if="!loading.paymentSubmission" @click.prevent="submit()" class="btn btn-fill btn-danger btn-wd">Sign Up!</button>
            <button type="button" v-if="loading.paymentSubmission" class="btn btn-wd btn-danger" disabled="disabled">
              <span class="btn-label">
                <i class="fa fa-circle-o-notch fa-spin"></i>
              </span>
              Sign Up!
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="row plans-footer">
      <p>Contact us for entrprise level plans and pricing for customized add-ons</p>
    </div>
  </div>
</template>
<script>
  import db from '@/components/firebase/init'
  import firebase from 'firebase'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'
  import { Card, createToken } from 'vue-stripe-elements-plus'
  import moment from 'moment'
  import { EventBus } from '@/eventBus'
  import swal from 'sweetalert2'

  export default {
    components: { Card },
    mixins: [toolboxMixin],
    data () {
      return {
        stripeSettings: {
          pubKey: process.env.STRIPE_PUB_KEY,
          options: {
            // see https://stripe.com/docs/stripe.js#element-options for details
            classes: {
              base: 'form-control'
            }
          },
          class: {
            complete: false
          },
          style: {
            base: {
              color: 'yellow',
              fontFamily: 'inherit',
              fontSmoothing: 'antialiased',
              fontSize: '16px',
              '::placeholder': {
                color: '#aab7c4'
              }
            },
            invalid: {
              color: '#fa755a',
              iconColor: '#fa755a'
            }
          }
        },
        complete: false,
        model: {
          coupon: '',
          stripe_token: '',
          plan_id: '',
          plan_name: ''
        },
        plan: {
          name: '',
          startDate: ''
        },
        plans: [
          {
            loading: false,
            id: 'plan_G3oWEPmzSSsUvb',
            name: 'Business Startup'
          },
          {
            loading: false,
            id: 'plan_FhkDbC6KWmoI3W',
            name: 'Small Business'
          },
          {
            loading: false,
            id: 'plan_FhkE565lgB0J87',
            name: 'Professional'
          }
        ],
        loading: {
          paymentSubmission: false,
          plan1: false,
          plan2: false,
          plan3: false
        }
      }
    },
    methods: {
      async init () {
        // nothing
      },
      selectPlan (planIndex) {
        // velocity('scroll', {
        //   duration: 3000,
        //   offset: 1000,
        //   easing: 'easeOutQuart',
        //   complete: function () {
        //       // done.
        //   }
        // })
        // this.$refs.planPayment.scrollIntoView()
        // Velocity(this.$refs.planPayment, 'scroll', { duration: 750, easing: 'ease-in' })
        // Velocity(this.$refs.planPayment, {
        //   translateY: '10px'
        // }, {
        //   loop: true
        // })
        this.plans[planIndex].loading = true
        let planId = this.plans[planIndex].id
        let getStripePlan = firebase.functions().httpsCallable('getStripePlan')
        getStripePlan({ planId: planId })
        .then(plan => {
          console.log(plan)
          this.model.plan_id = planId
          this.plan.name = plan.data.name
          this.plan.amount = plan.data.amount / 100
          this.plan.interval = plan.data.interval
          this.plan.startDate = moment().add(30, 'days').format('MMM Do')
          console.log(this.plan)
          this.plans[planIndex].loading = false
          this.model.plan_id = planId
          this.model.plan_name = this.plans[planIndex].name
          this.$refs.planPayment.scrollIntoView()
        })
        .catch(err => {
          alert(err.message)
        })

        // axios.get('https://api.authentic.net/get_stripe_plan.php?plan_id=plan_' + planId, this.axios_get_config)
        // .then((response) => {
        //   this.model.plan_id = 'plan_' + planId
        //   this.plan.name = response.data.name
        //   this.plan.amount = response.data.amount / 100
        //   this.plan.interval = response.data.interval
        //   this.stripe_plan_fetched = true
        // })
        // .catch((error) => {
        //   console.log(error)
        // })
      },
      submit () {
        // createToken returns a Promise which resolves in a result object with
        // either a token or an error key.
        // See https://stripe.com/docs/api#tokens for the token object.
        // See https://stripe.com/docs/api#errors for the error object.
        // More general https://stripe.com/docs/stripe.js#stripe-create-token.
        this.loading.paymentSubmission = true
        createToken().then((data) => {
          if (data.error) {
            swal.fire({
              title: 'Error',
              text: data.error.message,
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            })
            this.loading.paymentSubmission = false
          } else {
            console.log('stripe token')
            console.log(data.token.id)
            this.model.stripe_token = data.token.id
            this.submitPayment()
            // this.createStripeSubscription(data.token.id)
          }
        })
      },
      async submitPayment () {
        console.log('signing up')
        this.model.userToken = await firebase.auth().currentUser.getIdToken()
        console.log(this.model.userToken)
        let activatePayment = firebase.functions().httpsCallable('activatePayment')
        activatePayment(this.model)
        .then(result => {
          console.log(result)
          swal.fire({
            title: `Welcome!`,
            text: 'Your account was successfully created!',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            type: 'success'
          }).then(() => {
            this.loading.paymentSubmission = false
            EventBus.$emit('auth-refreshed')
            this.$router.replace({ name: 'Dashboard' })
          })
        })
        .catch(err => {
          console.error(err.message)
        })
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
        // Velocity(this.$refs.plans, {
        //   translateY: '10px'
        // }, {
        //   loop: true
        // })
      })
    }
  }
</script>
<style>
#plan-header-container {
  text-align: center;
  padding-bottom: 50px;
}
.plan-card {
  text-align: center;
}
.plan-card .btn {
  width: 80%;
}
.plan-card .no-cc-required {
  color: #9A9A9A;
  display: none;
}
.plan-card .plan-desc {
  border-bottom: 1px solid #dee1e1;
}
.plan-card .plan-desc h6 {
  text-transform: none;
}
.plan-card .plan-inc {
  padding-top: 10px;
  padding-bottom: 10px;
}
.plan-card ul {
  list-style-type: none;
  padding-left: 0;
}
.plan-card ul li div {
  padding-top: 10px;
  padding-bottom: 10px;
}
.plan-card ul li:before {
  display: block;
  width: 50%;
  height: 0;
  margin: .44444rem auto;
  border-top: 1px solid #dee1e1;
  content: "";
}
.featured-plan {
    -webkit-box-shadow: 0 0 28px rgba(22,32,32,.25), 0 10px 10px rgba(22,32,32,.22);
    box-shadow: 0 0 28px rgba(22,32,32,.25), 0 10px 10px rgba(22,32,32,.22);
    padding-top: 3.11111rem;
    padding-bottom: 3.11111rem;
}
.not-featured-plan {
  margin-top: 3.11111rem;
  margin-bottom: 3.11111rem;
}
.plans-footer {
  margin-top: 40px;
  text-align: center;
}
.stripe-card {
  width: 400px;
  margin: 0 auto;
}
.stripe-card base {
  color:lawngreen;
  font-family: inherit !important;
}
.stripe-card.complete {
  border-color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Plans/Plans.vue